import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import {
  RvCommunityMembers,
  RvCommunityPlatforms,
  RvCommunityAccelerated,
  RvCommunityIndustries,
} from "../../../../app-constants-updated";

function Commnitystats() {
  return (
    <section className="commnity_stats p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={5}
            xxl={6}
            className="order-2 order-xl-1 m-md-auto m-xl-0 mt-3 mt-md-4"
          >
            <StaticImage
              src="../../../images/landing/rv-community/comminity-stats.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={909}
              height={909}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={7}
            xxl={6}
            className="order-1 order-xl-2 my-auto "
          >
            <h2 style={{ color: "#000" }}>Community Stats</h2>
            <p>
              A Community that fosters growth and advances networking among
              industry peers.
            </p>
            <div className="community-main">
              <div className="community-item">
                <div className="community-flex">
                  <div className="community-icon">{RvCommunityMembers}</div>
                  <div className="community-content">
                    <h4>100K+</h4>
                    <p>Members</p>
                  </div>
                </div>
              </div>
              <div className="community-item">
                <div className="community-flex">
                  <div className="community-icon">{RvCommunityPlatforms}</div>
                  <div className="community-content">
                    <h4>5+</h4>
                    <p>Platforms</p>
                  </div>
                </div>
              </div>
              <div className="community-item">
                <div className="community-flex">
                  <div className="community-icon">{RvCommunityAccelerated}</div>
                  <div className="community-content">
                    <h4>27</h4>
                    <p>Accelerated Businesses</p>
                  </div>
                </div>
              </div>
              <div className="community-item">
                <div className="community-flex">
                  <div className="community-icon">{RvCommunityIndustries}</div>
                  <div className="community-content">
                    <h4>15+</h4>
                    <p>Industries Served</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Commnitystats;
